module.exports = __webpack_public_path__ + "img/Successful.c9679d91.png";